import { render, staticRenderFns } from "./TemperatureViolationsYearOverYear.vue?vue&type=template&id=470ebe3c&scoped=true&"
import script from "./TemperatureViolationsYearOverYear.vue?vue&type=script&lang=js&"
export * from "./TemperatureViolationsYearOverYear.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureViolationsYearOverYear.vue?vue&type=style&index=0&id=470ebe3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ebe3c",
  null
  
)

export default component.exports